import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { of, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TempStorageService } from './temp-storage.service';


@Injectable({
  providedIn: 'root'
})
export class UserReportService extends TempStorageService {
  constructor(private apollo: Apollo) {
    super()
  }

  queryStoreReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query storeReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            storeReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              id
              orderNumber
              dispatchNumber
              skuCode
              originEntity
              deliveryEntity
              totalQuantity
              deliveryQuantity
              pendingQuantity
              cancelledQuantity
              customerDocument
              customerName
              withdrawPersonDocument
              withdrawPerson
              withdrawDate
              locationNumber
              entityName
              programmedDeliveryDate
              locationDate
              finalEntityArrivalDate
              productDescription
              contactEmail
              contactPhone
              stateProduct
              state
              lpnNumber
              locationLpn
              returnedQuantity
              returnStatusDate
              returnSellerStatusDate
              courrierName
              isCourrier
              division
              withdrawalEffectiveDate
              reasonCancellation
              channel
              deliveryAgreement
              reasonForReturn
              scomments
              currentEntity
              originGroupName
              finalGroupName
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  storeReportPromise(filterReport) {
    return this.queryStoreReport(filterReport).toPromise();
  }

  dispatchReportPromise(filterReport) {
    return this.queryDispatchReport(filterReport).toPromise();
  }

  saleNoteReportPromise(filterReport) {
    return this.querySaleNoteReport(filterReport).toPromise();
  }

  dispatchHistoryReportPromise(filterReport) {
    return this.queryDispatchHistoryReport(filterReport).toPromise()
  }

  queryDispatchReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query dispatchReportDataStudio(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            dispatchReportDataStudio(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              currentEntityName
              stateName
              deliveryDate
              originType
              originEntity
              saleLocationName
              deliveryEntity
              route
              saleNoteId
              dispatchId
              skuCode
              skuPartialSequence
              lpn
              location
              skuName
              pendingAmount
              processedAmount
              canceledAmount
              totalAmount
              saleDate
              dispatchDate
              customerDocumentNumber
              firstName
              lastName
              contactPhone
              contactEmail
              department
              province
              district
              deliveryAddress
              zoneName
              dispatchTypeName
              purchaseOrderNumber
              ecommerceId
              saleUser
              dispatchTripId
              entityTrip
              stateTrip
              createdDateTrip
              originTrip
              stateGuia
              chargeNumber
              guideNumber
              tripShippingDate
              receptionDate
              #cancellationDetail
              cancellationDate
              paymentState
              originalDeliveryDate
              lineDescription
              departmentDescription
              areaDescription
              divisionDescription
              paymentMethod
              rucCarrier
              businessNameCarrier
              attemptsDelivery
              orderPrecancelledDate
              weight
              volume
              generatedPmmAt
              generatedInternmentAt
              productSize
              channel
              quotationNumber
              deliveryAgreement
              paymentDate
              withdrawStatus
              division
              originalCompanyCode
              deliveryRecordUser
              deliveryTransactionDate
              pickingDate
              startDeliveryWindow
              endDeliveryWindow
              preCancellationReason
              tripType
              trackingDeliveryDate
              deliveryCompliance
              inFullCompliance
              arrivalCompliance
              locationCompliance
              withdrawPerson
              withdrawPersonDocument
              pickingDateFrom
              pickingDateTo
              palletNbr
              reference
              originGroupName
              groupName
              nextGroupName
              finalGroupName
              geoLocalization
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }


  queryCountDispatchReport(filterReport?) {
    return this.apollo.use('user-report')
      .query({
        query: gql`
        query countDispatchReportDataStudio(
          $filterInput: FilterInput
          ) {
            countDispatchReportDataStudio(
              filterInput: $filterInput
            )
        }
      `,
        variables: {
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryCountWithdrawReport(filterReport?) {
    return this.apollo.use('user-report')
      .query({
        query: gql`
        query countStoreReport(
          $filterInput: FilterInput
          ) {
            countStoreReport(
              filterInput: $filterInput
            )
        }
      `,
        variables: {
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryDispatchHistoryReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query dispatchHistoryReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            dispatchHistoryReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              event
              eventDescription
              saleNoteId
              dispatchId
              skuCode
              skuPartialSequence
              description
              dispatchStatus
              dispatchStatusDescription
              currentEntity
              currentEntityName
              nextEntity
              nextEntityName
              lpn
              units
              transactionDetail
              rejectName
              origin
              reasonCancellation
              stateDate
              username
              locationLpn
              dispatchTripId
              locationWithdrawal
              saleDate
              groupName
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryCancellationTicketReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query cancellationTicketReport(
          $limit: Int
          $offset: Int
          $filterInput: FilterInput
        ) {
          cancellationTicketReport(
            limit: $limit
            offset: $offset
            filterInput: $filterInput
          ) {
            companyCode
            orderNumber
            ticketNumber
            cancellationEntity
            username
            cancellationDate
            saleDate
            saleEntityCode
            saleEntity
            dispatchNumber
            skuCode
            skuPartialSequence
            units
            unitsCanceled
            lineDescription
            departmentDescription
            areaDescription
            divisionDescription
            reasonCancellation
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryCancelledReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query dispatchReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            dispatchReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              saleNoteId
              dispatchId
              skuCode
              skuPartialSequence
              dispatchTypeName
              customerDocumentNumber
              firstName
              lastName
              withdrawPersonDocument
              withdrawPerson
              pendingAmount
              processedAmount
              currentEntityName
              saleLocationName
              route
              originEntity
              deliveryEntity
              zoneName
              stateName
              deliveryDate
              saleDate
              deliveryAddress
              department
              province
              district
              skuName
              contactPhone
              contactEmail
              originType
              lpn
              paymentState
              ecommerceId
              saleUser
              cancellationDate
              purchaseOrder{
                purchaseOrderNumber
              }
              productItem{
                hierarchyCode
                hierarchyDetail{
                  lineDescription
                  departmentDescription
                  areaDescription
                  divisionDescription
                }
              }
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryArrearReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query arrearReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            arrearReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              saleNoteId
              dispatchId
              skuCode
              skuPartialSequence
              dispatchTypeName
              customerDocumentNumber
              firstName
              lastName
              pendingAmount
              processedAmount
              currentEntityName
              saleLocationName
              route
              zoneName
              stateName
              deliveryDate
              deliveryAddress
              skuName
              lpn
              dispatchEntity{
                routeEntity
                entityName
              }
              dispatchHistory{
                deliveredDate
                pendingReception
                pendingDispatch
              }
              dispatchItemInitial{
                originalCreationAmount
              }
              productItem{
                hierarchyCode
                hierarchyDetail{
                  lineDescription
                  departmentDescription
                  areaDescription
                  divisionDescription
                }
              }
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  querySaleNoteStatusReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query saleNoteStatusReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            saleNoteStatusReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              nvCode
              requestAmountNv
              requestAmountSkuNv
              state{
                stateName
              }
              saleDate
              customerFirstName
              customerLastName
              documentType
              customerDocument
              contactPhone
              ecommerceId
              contactEmail
              saleLocationName
              priceEditUsername,
              totalAmount
              paymentOrder{
                saleUser
              }
              dispatch{
                dispatchType
                dispatchCode
                deliveryDate
                deliveryMode
                route
                routeDetail
                entityMng{
                  entityCode
                  entityType
                  entityName
                  entityAddress
                }
                destinyAddress
                division
                requestAmountDispatch
                processedAmountDispatch
                state{
                  stateName
                }
                dispatchNumber
                originCode
                originType
                withdrawPersonDocument
                withdrawPerson
                zoneId
                address{
                  address
                  addressType
                  floor
                  latitude
                  longitude
                  number
                  reference
                  ubigeo{
                    ubigeoCode
                    department
                    province
                    district
                  }
                  ubigeoCode
                  wayType
                  zoneId
                }
                dispatchItemsMng{
                  lpn
                  dispatchId
                  skuCode
                  skuPartialSequence
                  stateName
                  skuName
                  currentEntity
                  productType
                  dispatchDate
                  dispatchItemInitial{
                    productLine
                  }
                  state{
                    stateName
                    editable
                  }
                  dispatchHistory{
                    deliveredDate
                  }
                  processedAmount
                  pendingAmount
                  saleNoteTransaction{
                    entity
                    lpnNumber
                    transaction
                    transactionDate
                    username
                  }
                }
                saleNoteItem{
                  id
                  skuCode
                  dispatchId
                  skuName
                  productType
                  currentEntity
                  productLine
                  stateId
                  state{
                    stateName
                    editable
                  }
                  units
                  cancelled
                  availableItems
                  saleNoteTransaction{
                    entity
                    lpnNumber
                    transaction
                    transactionDate
                    username
                  }
                }
              }
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  querySaleNoteReport(filterReport?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query saleNoteReport(
          $limit: Int,
          $offset: Int,
          $filterInput: FilterInput
          ) {
            saleNoteReport(
              limit: $limit,
              offset: $offset,
              filterInput: $filterInput
            ) {
              companyCode
              saleNoteId
              dispatchId
              quotationNumber
              salelocation
              ecommerceId
              paymentState
              stateName
              skuCode
              skuPartialSequence
              skuName
              lineDescription
              departmentDescription
              areaDescription
              divisionDescription
              purchasedAmount
              deliveredAmount
              cancelledAmount
              price
              totalPrice
              itemState
              customerDocumentType
              customerDocumentNumber
              firstName
              lastName
              contactPhone
              contactEmail
              saleDate
              paymentDate
              deliveryDate
              startDateDeliveryWindow
              endDateDeliveryWindow
              deliveryAgreement
              dispatchTypeCode
              dispatchTypeName
              route
              originType
              routeEntity
              saleLocationName
              saleUser
              cancellationDate
              reasonCancellation
              userCancellation
              productType
              conversionFactor
              originRoute
              deliveryRoute
              adjustWMS
              channel
              originEntity
              deliveryEntity
              generatedASN
              division
              originGroupName
              finalGroupName
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          filterInput: filterReport.filterInput
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryLstDispatchState() {
    const settingEntityStorage = this.getStorage('REPORT_DISPATCH_STATE');
    return settingEntityStorage ?
      of(settingEntityStorage) :
      this.apollo.use('dispatch-report')
        .query({
          query: gql`
              query listDispatchState {
                  listDispatchState {
                    id
                    companyCode
                    stateCode
                    stateName
                }
              }
            `,
          fetchPolicy: 'network-only',
          errorPolicy: 'all'
        }).pipe(tap(res => this.setStorage('REPORT_DISPATCH_STATE', res)));
  }

  queryLstStateByType(stateType?) {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
              query listStateByType(
                $stateType: String
                ) {
                  listStateByType(
                    stateType: $stateType
                  ) {
                    id
                    companyCode
                    stateName
                    stateType
                }
              }
            `,
        variables: {
          stateType: stateType
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryLstModificationType() {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
              query listModificationType{
                listModificationType{
                    id
                    value
                }
              }
            `,
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryLstEventTransaction() {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
              query listEventTransaction{
                listEventTransaction{
                    id
                    value
                }
              }
            `,
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryDispatchesDelivered(filterReport: any): Observable<any> {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query dispatchesDelivered(
          $limit: Int,
          $offset: Int,
          $settlementReportFilters: SettlementReportFilters
          ) {
            dispatchesDelivered(
              limit: $limit,
              offset: $offset,
              settlementReportFilters: $settlementReportFilters
            ) {
              deliveryTypeName
              dispatchTripId
              skuCode
              ecommerceId
              customer
              district
              paymentDate
              dispatchDate
              dispatchAssistant
              state
              dispatchId
              paymentMethod
              amount
              processedAmount
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          settlementReportFilters: filterReport.settlementReportFilters
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

  queryReturnedDispatches(filterReport: any): Observable<any> {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query returnedDispatches(
          $limit: Int,
          $offset: Int,
          $settlementReportFilters: SettlementReportFilters
          ) {
            returnedDispatches(
              limit: $limit,
              offset: $offset,
              settlementReportFilters: $settlementReportFilters
            ) {
              deliveryTypeName
              dispatchTripId
              skuCode
              ecommerceId
              customer
              district
              paymentDate
              dispatchDate
              dispatchAssistant
              state
              dispatchId
              paymentMethod
              amount
              amountReturned
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          settlementReportFilters: filterReport.settlementReportFilters
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }


  queryCanceledDispatches(filterReport: any): Observable<any> {
    return this.apollo.use('dispatch-report')
      .query({
        query: gql`
        query dispatchesCanceled(
          $limit: Int,
          $offset: Int,
          $settlementReportFilters: SettlementReportFilters
          ) {
            dispatchesCanceled(
              limit: $limit,
              offset: $offset,
              settlementReportFilters: $settlementReportFilters
            ) {
              deliveryTypeName
              dispatchTripId
              skuCode
              ecommerceId
              customer
              district
              paymentDate
              dispatchDate
              dispatchAssistant
              state
              dispatchId
              paymentMethod
              amount
              canceledAmount
          }
        }
      `,
        variables: {
          limit: filterReport.limit,
          offset: filterReport.offset,
          settlementReportFilters: filterReport.settlementReportFilters
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      });
  }

}
